<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo-b.png" alt="logo图">
    </div>
    <p class="title">深圳市阿蒂森技术服务有限公司</p>
    <p class="address_tel_fax">
      <span>深圳市龙华区大浪街道上横朗社区福龙路旁恒大时尚慧谷大厦10栋A506 </span>
<!--      <span>Tel：888-888-888</span>-->
    </p>
    <p class="email_wx">
<!--      <span>邮箱：liyunkun_11@163.com</span>-->
<!--      <span>公司微信号：ilyk_gg</span>-->
    </p>
    <p class="copy">Copyright &copy; 2018 - 2023 深圳市阿蒂森技术服务有限公司 备案号：<a @click="toLink" href="#javascript" class="clo-wit">粤ICP备2023012490号-1</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('https://beian.miit.gov.cn/')
    }
  }
};
</script>
<style scoped>
.clo-wit{
  color: #d3d3d3;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 60px;
  /* height: 45px; */
  margin: 50px auto 20px;
}
.logo img{
  width: 60px;
  /* height: 45px; */
  display: block;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue